const KEY = "pedido_publico";
const DOMICILIO_BASE = 0;

const uuid = () =>
  crypto?.randomUUID
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2) + Date.now().toString(36);

const normalizeExtras = (extras = []) =>
  extras
    .filter((e) => e && e.qty > 0)
    .map((e) => ({
      id: e.id ?? null,
      name: e.name,
      price: Number(e.price || 0),
      qty: Number(e.qty || 0),
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

const calcularUnitPrice = (precioBase, extras = []) => {
  const extrasTotal = extras.reduce(
    (sum, e) => sum + Number(e.price || 0) * Number(e.qty || 0),
    0
  );
  return Number(precioBase || 0) + extrasTotal;
};

export const getCarrito = () => {
  const data = localStorage.getItem(KEY);
  return data ? JSON.parse(data) : { items: [] };
};

export const saveCarrito = (carrito) => {
  localStorage.setItem(KEY, JSON.stringify(carrito));
};

export const clearCarrito = () => {
  localStorage.removeItem(KEY);
};

export const addItem = (item) => {
  const carrito = getCarrito();

  const extras = normalizeExtras(item.extras);
  const unitPrice = calcularUnitPrice(item.precioBase, extras);

  carrito.items.push({
    lineId: uuid(),

    productId: item.id,
    nombre: item.nombre,
    categoria: item.categoria,

    precioBase: Number(item.precioBase || 0),

    config: {
      base: item.base || "",
      extras,
    },

    nota: item.nota || "",
    unitPrice,
    cantidad: Number(item.cantidad || 1),
  });

  saveCarrito(carrito);
};

export const updateItemCantidad = (lineId, cantidad) => {
  const carrito = getCarrito();
  carrito.items = carrito.items
    .map((p) =>
      p.lineId === lineId ? { ...p, cantidad: Number(cantidad || 0) } : p
    )
    .filter((p) => p.cantidad > 0);

  saveCarrito(carrito);
};

export const updateItemNota = (lineId, nota) => {
  const carrito = getCarrito();
  carrito.items = carrito.items.map((p) =>
    p.lineId === lineId ? { ...p, nota } : p
  );
  saveCarrito(carrito);
};

export const removeItem = (lineId) => {
  const carrito = getCarrito();
  carrito.items = carrito.items.filter((p) => p.lineId !== lineId);
  saveCarrito(carrito);
};

export const updateItemConfig = (lineId, data) => {
  const carrito = getCarrito();

  carrito.items = carrito.items.map((p) => {
    if (p.lineId !== lineId) return p;

    const extras = data.config?.extras || p.config.extras;
    const precioBase = data.precioBase ?? p.precioBase;
    const unitPrice = calcularUnitPrice(precioBase, extras);

    return {
      ...p,
      config: {
        ...p.config,
        ...data.config,
      },
      nota: data.nota ?? p.nota,
      cantidad: data.cantidad ?? p.cantidad,
      unitPrice,
    };
  });

  saveCarrito(carrito);
};


// ===============================
// Totales
// ===============================
export const getItemTotal = (item) =>
  Number(item.unitPrice || 0) * Number(item.cantidad || 0);

export const getSubtotal = () => {
  const carrito = getCarrito();
  return carrito.items.reduce((sum, p) => sum + getItemTotal(p), 0);
};

export const getDomicilio = () => {
  const carrito = getCarrito();
  return carrito.items.length > 0 ? DOMICILIO_BASE : 0;
};

export const getTotal = () => getSubtotal() + getDomicilio();

export const countItems = () => {
  const carrito = getCarrito();
  return carrito.items.reduce((sum, p) => sum + (p.cantidad || 0), 0);
};
